<template>
  <div>
    <regist></regist>
  </div>
</template>
<script>
import regist from '@/components/account/regist.vue'
export default {
  name: 'register',
  components: {
    'regist': regist
  },
  data () {
    return {
    }
  },
  methods: {

  }
}
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// src/page/register.vue